$(function() {
    $(window).on('softpage:opened', function() {
        $('.softpage-visible .tingle-modal__close, .softpage-visible .app-detail__header-col .tingle-modal__close').on('click', function() {
            $(window).trigger('closeSoftpage');
        });
    });
})



// WEBPACK FOOTER //
// ./static/js/modules/softpage.js